import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { mapArrayElement } from "../../../helpers";
export function mapEvents(eventsMap) {
    const mappedEvents = {};
    for (const [eventId, eventArray] of Object.entries(eventsMap)) {
        mappedEvents[eventId] = mapEvent(eventArray);
    }
    return mappedEvents;
}
function mapParticipants(participantsArray) {
    return participantsArray ? participantsArray.map(participant => ({
        id: participant[0],
        name: participant[1],
        venueRole: participant[2],
        country: participant[3],
        metadata: participant[4],
        isNationalTeam: participant[5],
        countryCode: participant[6],
    })) : participantsArray;
}
function mapEvent(eventArray) {
    return {
        sportId: eventArray[0],
        eventId: eventArray[1],
        eventStartDate: eventArray[2],
        eventType: eventArray[3],
        eventDisplayName: eventArray[4],
        isTeamSwap: eventArray[5],
        homeTeamName: eventArray[6],
        awayTeamName: eventArray[7],
        isLive: eventArray[8],
        status: eventArray[9],
        gameScore: mapArrayElement(eventArray[10], mapGameScore),
        liveGameState: mapArrayElement(eventArray[11], mapLiveGameState),
        tags: eventArray[12],
        participants: mapParticipants(eventArray[13]),
        media: eventArray[14],
        leagueId: eventArray[15],
    };
}
export function mapGameScore(gameScoreArray) {
    return {
        homeScore: gameScoreArray[0],
        awayScore: gameScoreArray[1],
        isSettlementScore: gameScoreArray[2],
        combinedSecondTierScores: gameScoreArray[3],
        additionalScores: gameScoreArray[4]
    };
}
export function mapLiveGameState(liveGameStateArray) {
    return {
        clockRunning: liveGameStateArray[0],
        clockDirection: liveGameStateArray[1],
        gameTime: liveGameStateArray[2],
        gamePart: getTruthyValue(liveGameStateArray[3], undefined)
    };
}
//# sourceMappingURL=mapEvent.js.map